import CommercialPlan from "./CommercialPlan";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useState } from "react";
// import { useHistory } from "react-router-dom";
import { PayHeader } from "../../Paymentheader/PayHeader";
import { EditOutlined } from "@ant-design/icons";
import { Modal } from "antd/lib";
import VehicleEdit from "../PlanEdit/VehicleEdit";
import CommercialPrevpolictype from "../PlanEdit/PrevPolicyType";
import CommercialOwmeredit from "../PlanEdit/OwnerTypeEdit";
import CommerPrevpolexp from "../PlanEdit/PrevPolicyExpEdit";
import CommerRegDateUpdate from "../PlanEdit/RegDateEdit";
import {
  getCommercialDetails,
  getComQuickQuotePost,
  getComQuickQuoteInput,
  fetchPreviousInsurers,
} from "../../../Redux/actions/CommercialSlice";

export const PlanLayoutCommercial = () => {
  const dispatch = useDispatch();
  // const history = useHistory();
  const CommerDetail = useSelector(getCommercialDetails);
  const QuickQuotePost = useSelector(getComQuickQuotePost);
  const QuoteInput = useSelector(getComQuickQuoteInput);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOwner, setisModalOwner] = useState(false);
  const [isModalExp, setisModalExp] = useState(false);
  const [isModalReg, setisModalReg] = useState(false);
  const [isModalBike, setisModalBike] = useState(false);
  const [loading, setLoading] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [mainType, setMainType] = useState("");
  const [fuelType, setFuelType] = useState("");

  const handleScroll = () => {
    if (window.scrollY > 80) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  useEffect(() => {
    dispatch(fetchPreviousInsurers());
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [dispatch]);

  useEffect(() => {
    const inputString = CommerDetail?.varient;
    const match = inputString?.match(/\(([^)]+)\)$/);
    if (match) {
      const result = match[1];
      // console.log(result);
      if (result === "P") {
        setFuelType("PETROL");
      } else if (result === "D") {
        setFuelType("DIESEL");
      } else if (result === "E") {
        setFuelType("ELECTRIC");
      } else if (result === "BATTERY") {
        setFuelType("BATTERY");
      }
    } else {
      console.log("No match found.");
    }
    const Type = CommerDetail?.commercialType;
    switch (Type) {
      case "GOODS COMMERCIAL VEHICLE":
        setMainType("GCV");
        break;
      case "PASSENGER COMMERCIAL VEHICLE":
        setMainType("PCV");
        break;
      case "MISCELLANEOUS VEHICLE":
        setMainType("MISC-D");
        break;
      default:
        setMainType("");
    }
  }, []);

  const policyTypeClick = () => {
    setIsModalOpen(true);
  };
  const ownerType = () => {
    setisModalOwner(true);
  };
  const HandleExp = () => {
    setisModalExp(true);
  };
  const HandleReg = () => {
    setisModalReg(true);
  };
  const HandleBike = () => {
    setisModalBike(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const handleCancelOwn = () => {
    setisModalOwner(false);
  };
  const handleCancelExp = () => {
    setisModalExp(false);
  };
  const handleCancelReg = () => {
    setisModalReg(false);
  };
  const handleCancelBike = () => {
    setisModalBike(false);
  };

  return (
    <div>
      <PayHeader />
      <div className={scrolled ? `sticky` : `editquote`}>
        <div className="row justify-content-center">
          <div className="col-xl-2 col-lg-12 col-md-12 col-sm-12 edit-layout">
            <div className="editbike">
              <div className="editvalueq">
                {CommerDetail?.make} {CommerDetail?.model}
              </div>
            </div>
            <div className="editbike">
              {mainType} | {fuelType} |{" "}
              <div className="editvalueq">
                {QuickQuotePost?.licensePlateNumber}
              </div>
              <EditOutlined
                key="save"
                style={{ cursor: "pointer" }}
                onClick={HandleBike}
              />
            </div>
          </div>
          <div className="col-xl-3 col-lg-12 col-md-12 col-sm-12 edit-layout">
            <div className="editbike">
              PREVIOUS POLICY TYPE:{" "}
              {QuoteInput?.insuranceProductCode === "package" ? (
                <div className="editvalueq">COMPREHENSIVE</div>
              ) : QuoteInput?.insuranceProductCode === "tp" ||
                QuoteInput?.insuranceProductCode === "Not_Secure" ? (
                <div className="editvalueq">THIRD-PARTY</div>
              ) : (
                ""
              )}
              <EditOutlined
                key="save"
                style={{ cursor: "pointer" }}
                onClick={policyTypeClick}
              />
            </div>
            <div className="editbike">
              OWNERSHIP:{" "}
              <div className="editvalueq">
                {QuickQuotePost?.policyHolderType}
              </div>
              <EditOutlined
                key="save"
                style={{ cursor: "pointer" }}
                onClick={ownerType}
              />
            </div>
          </div>
          <div className="col-xl-3 col-lg-12 col-md-12 col-sm-12 edit-layout">
            <div className="editbike">
              PREVIOUS POLICY EXPIRY:{" "}
              <div className="editvalueq">
                {QuickQuotePost?.previousPolicyExpiryDate}
              </div>
              <EditOutlined
                key="save"
                style={{ cursor: "pointer" }}
                onClick={HandleExp}
              />
            </div>
            <div className="editbike">
              REGISTERED ON:{" "}
              <div className="editvalueq">
                {QuickQuotePost?.registrationDate}
              </div>
              <EditOutlined
                key="save"
                style={{ cursor: "pointer" }}
                onClick={HandleReg}
              />
            </div>
          </div>
          <div className="col-xl-2 col-lg-12 col-md-12 col-sm-12 edit-layout">
            <div className="editbike">
              Previous NCB :{" "}
              <div className="editvalueq">
                {QuoteInput?.ncbvalue === 0
                  ? "0%"
                  : QuoteInput?.ncbvalue === 20
                  ? "20%"
                  : QuoteInput?.ncbvalue === 25
                  ? "25%"
                  : QuoteInput?.ncbvalue === 35
                  ? "35%"
                  : QuoteInput?.ncbvalue === 45
                  ? "45%"
                  : QuoteInput?.ncbvalue === 50
                  ? "50%"
                  : QuoteInput?.productCode === "PVT"
                  ? "N/A"
                  : ""}
              </div>
              {/* <EditOutlined key="save" style={{cursor: "pointer"}} onClick={HandleExp}/> */}
            </div>
            <div className="editbike">
              Current Applicable NCB :{" "}
              <div className="editvalueq">
                {QuoteInput?.ncbvalue === 0
                  ? "20%"
                  : QuoteInput?.ncbvalue === 20
                  ? "25%"
                  : QuoteInput?.ncbvalue === 25
                  ? "30%"
                  : QuoteInput?.ncbvalue === 35
                  ? "45%"
                  : QuoteInput?.ncbvalue === 45
                  ? "50%"
                  : QuoteInput?.ncbvalue === 50
                  ? "50%"
                  : QuoteInput?.productCode === "PVT"
                  ? "0%"
                  : ""}
              </div>
              {/* <EditOutlined key="save" style={{cursor: "pointer"}} onClick={HandleReg}/> */}
            </div>
          </div>
        </div>
      </div>

      <CommercialPlan />
      <p className="exclusive" variant="h9">
        *Validity of the Quotation is till the end of the day on which the quote
        is generated
      </p>

      <Modal
        title="What type of policy did you buy last year?"
        open={isModalOpen}
        footer={null}
        onCancel={handleCancel}
        maskClosable={false}
      >
        <CommercialPrevpolictype
          setIsModalOpen={setIsModalOpen}
          CommerDetail={CommerDetail}
        />
      </Modal>
      <Modal
        title="Choose the Journey Type"
        open={isModalOwner}
        footer={null}
        onCancel={handleCancelOwn}
        maskClosable={false}
      >
        <CommercialOwmeredit
          setisModalOwner={setisModalOwner}
          CommerDetail={CommerDetail}
        />
      </Modal>
      <Modal
        title="Select Previous Policy Expiration Date"
        open={isModalExp}
        footer={null}
        onCancel={handleCancelExp}
        maskClosable={false}
      >
        <CommerPrevpolexp
          setisModalExp={setisModalExp}
          CommerDetail={CommerDetail}
        />
      </Modal>
      <Modal
        title="Registration Year"
        open={isModalReg}
        footer={null}
        onCancel={handleCancelReg}
        maskClosable={false}
      >
        <CommerRegDateUpdate
          setisModalReg={setisModalReg}
          CommerDetail={CommerDetail}
        />
      </Modal>
      <Modal
        title="Vehicle Details"
        open={isModalBike}
        footer={null}
        onCancel={handleCancelBike}
        maskClosable={false}
      >
        <VehicleEdit setisModalBike={setisModalBike} />
      </Modal>
    </div>
  );
};

export default PlanLayoutCommercial;
